"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollLinkType = void 0;
exports.instanceOfPayrollLinkType = instanceOfPayrollLinkType;
exports.PayrollLinkTypeFromJSON = PayrollLinkTypeFromJSON;
exports.PayrollLinkTypeFromJSONTyped = PayrollLinkTypeFromJSONTyped;
exports.PayrollLinkTypeToJSON = PayrollLinkTypeToJSON;
exports.PayrollLinkTypeToJSONTyped = PayrollLinkTypeToJSONTyped;
/**
 *
 * @export
 */
exports.PayrollLinkType = {
    Onboarding: 'onboarding',
    Dashboard: 'dashboard',
    I9: 'i9',
    Paystub: 'paystub'
};
function instanceOfPayrollLinkType(value) {
    for (const key in exports.PayrollLinkType) {
        if (Object.prototype.hasOwnProperty.call(exports.PayrollLinkType, key)) {
            if (exports.PayrollLinkType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function PayrollLinkTypeFromJSON(json) {
    return PayrollLinkTypeFromJSONTyped(json, false);
}
function PayrollLinkTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PayrollLinkTypeToJSON(value) {
    return value;
}
function PayrollLinkTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=PayrollLinkType.js.map